<template>
  <div class="company-tab">
    <el-form class="form" :inline="true" v-show="isBranchCompany">
      <el-form-item label="分部名称">
        <el-input v-model="CompanySearch.Name" placeholder="请输入分部名称" style="width: 260px;"></el-input>
      </el-form-item>
      <el-form-item label="省市区">
        <el-cascader v-model="CompanySearch.Place" style="width: 260px" :options="Provinces" clearable @active-item-change="handleItemChange" :props="{value: 'Id', label: 'Name', children: 'children'}" placeholder="请选择办事处（省/市/区）"></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" style="background: #20a0ff; width: 120px;" :loading="regionLoading" @click="getRegion">查询</el-button>
      </el-form-item>
    </el-form>
    
    <div class="btn-group">
      <el-button :class="['btn', isBranchCompany ? '': 'active']" @click="handleTabClick({flag: 'zongbu'})">总部信息</el-button>
      <el-button :class="['btn', isBranchCompany ? 'active': '']" @click="handleTabClick({flag: 'fenbu'})">分部信息</el-button>
      <el-button class="btn btn002" @click="handleBranchCompanyDialogOpen()">新增分部</el-button>
    </div>
    
    <div class="card-list">
      <div class="card" v-show="!isBranchCompany">
        <h4>{{Company.CardName}}</h4>
        <el-form class="form" label-width="110px" label-suffix="：" label-position="right">
          <el-form-item class="form-item" label="公司地址">{{Company.ProvinceName}}{{Company.CityName}}{{Company.AreaName}}{{Company.Address}}</el-form-item>
          <el-form-item class="form-item" label="联系电话">{{Company.Phone}}</el-form-item>
          <el-form-item class="form-item" label="公司邮箱">{{Company.Email}}</el-form-item>
          <el-form-item class="form-item" label="公司QQ">{{Company.QQ}}</el-form-item>
          <el-form-item class="form-item" label="公司微信">{{Company.WeChat}}</el-form-item>
          <el-form-item class="form-item" label="公司传真">{{Company.Fax}}</el-form-item>
          <el-form-item class="form-item" label="公司开票代码">{{Company.InvoiceCode}}</el-form-item>
          <el-form-item class="form-item" label="公司网址">{{Company.CardUrl}}</el-form-item>
        </el-form>
        <div class="btn-area" style="top: 6px">
          <el-button type="text" @click="handleCompanyDialogOpen">编辑</el-button>
        </div>
      </div>
      <template v-if="isBranchCompany">
        <div class="card" v-loading="regionLoading" element-loading-text="加载中" v-for="BranchCompany in BranchCompanys" :key="BranchCompany.Id">
          <el-form class="form" style="margin-top: 0" label-width="110px" label-suffix="：" label-position="right">
            <el-form-item class="form-item" label="分部名称">{{BranchCompany.Name}}</el-form-item>
            <el-form-item class="form-item" label="分部地址">{{BranchCompany.Province && BranchCompany.Province.Name}} {{BranchCompany.City && BranchCompany.City.Name}} {{BranchCompany.County && BranchCompany.County.Name}} {{BranchCompany.Address}}</el-form-item>
            <el-form-item class="form-item" label="分部联系方式">{{BranchCompany.MobilePhone}}</el-form-item>
          </el-form>
          <div class="btn-area">
            <el-button type="text" @click="handleBranchCompanyDialogOpen(BranchCompany)">编辑</el-button>
            <el-button type="text" class="danger" @click="handleRemoveBranchCompany(BranchCompany)">删除</el-button>
          </div>
        </div>
      </template>
    </div>

    <company-dialog :form="Dialog.form"  :show.sync="Dialog.show" @confirm="handleConfirm"></company-dialog>
    <branch-company-dialog :form="BranchDialog.form" :show.sync="BranchDialog.show" @confirm="handleBranchConfirm"></branch-company-dialog>
  </div>
</template>

<script>
import CompanyDialog from './CompanyDialog'
import BranchCompanyDialog from './BranchCompanyDialog'
import o from '@/odata'
export default {
  data() {
    return {
      Company: {},
      Dialog: {
        show: false,
        form: {},
      },
      BranchDialog: {
        show: false,
        form: {},
      },
      BranchCompanys: [],
      Provinces: [],
      isBranchCompany: false,
      CompanySearch: {
        Name: null,
        Place: [],
      },
      regionLoading: false, // 查询分部按钮是否在加载中
    }
  },
  methods: {
    getCompany() {
      o('Partner/Services.GetCustomer()').get().then(({ data }) => {
        if (data) {
          this.Company = data
        }
      })
    },
    getRegion() {
      this.regionLoading = true
      let regionQuery = o(`PartnerRegion`)
      let filters = []
      if (this.CompanySearch.Name) {
        filters.push(`contains(Name, '${this.CompanySearch.Name}')`)
      }
      console.log(this.CompanySearch.Place[0])
      if (this.CompanySearch.Place[0]) {
        filters.push(`ProvinceId eq ${this.CompanySearch.Place[0]}`)
        filters.push(`CityId eq ${this.CompanySearch.Place[1]}`)
        filters.push(`CountyId eq ${this.CompanySearch.Place[2]}`)
      }
      if (filters.length > 0) {
        regionQuery.filter(filters.join(' and '))
      }
      regionQuery.expand('City($select=Id,Code,Name)')
      regionQuery.expand('Province($select=Id,Code,Name)')
      regionQuery.expand('County($select=Id,Code,Name)')
      regionQuery.get().then(({ data }) => {
        if (data) {
          this.BranchCompanys = data
        }
        this.regionLoading = false
      })
    },
    getProvinces() {
      o('Province').get().then(({ data }) => {
        this.Provinces = data.map(province => {
          province.children = []
          return province
        })
      })
    },
    handleTabClick({ flag }) {
      console.log(flag)
      if (flag === 'zongbu') {
        this.isBranchCompany = false
        this.getCompany()
      } else {
        this.isBranchCompany = true
        this.getRegion()
      }
    },
    handleItemChange(val) {
      const Province = this.Provinces.find((province) => province.Id === val[0])
      let City
      if (val[1]) {
        City = Province.children.find((city) => city.Id === val[1])
      }
      if (Province.children.length === 0) {
        o('City').filter(`Province/Id eq ${val}`).get().then(({ data }) => {
          this.$set(Province, 'children', data.map(city => {
            city.children = []
            return city
          }))
        })
      } else if (City && City.children.length === 0) {
        o('County').filter(`City/Id eq ${val[1]}`).get().then(({ data }) => {
          this.$set(City, 'children', data)
        })
      }
    },
    handleCompanyDialogOpen() {
      this.Dialog.form = this.Company
      this.Dialog.show = true
    },
    handleConfirm(form) {
      console.log('confirm', form)
      o('Partner/Services.EditCustomer').post(form).save().then(({data}) => {
        this.Dialog.show = false
        this.$message.success('保存成功!')
        this.getCompany()
      }).catch(err => {
        this.$alert(err)
      })
    },
    handleBranchCompanyDialogOpen(BranchCompany) {
      this.BranchDialog.show = true
      this.BranchDialog.form = BranchCompany || {}
    },
    handleBranchConfirm(form) {
      let promise
      const state = this.$store.state
      const { customerId } = state.currentCostomer
      Object.assign(form, {
        PartnerId: customerId,
      })
      if (form.Id) {
        promise = o(`PartnerRegion(${form.Id})`).patch(form).save()
      } else {
        promise = o(`PartnerRegion`).post(form).save()
      }
      promise.then(() => {
        this.Company = form
        this.BranchDialog.show = false
        this.$message.success('保存成功!')
        this.getCompany()
        this.getRegion()
      }).catch(err => {
        this.$alert(err)
      })
    },
    handleRemoveBranchCompany(BranchCompany) {
      this.$confirm('即将删除分部，请慎重操作！', '删除分部', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        o(`PartnerRegion(${BranchCompany.Id})`).remove().save()
        .then(() => {
          this.$message.success('删除成功!')
          this.getRegion()
        })
      }).catch(() => { })
    },
  },
  mounted() {
    this.getCompany()
    this.getProvinces()
    this.getRegion()
  },
  components: {
    CompanyDialog,
    BranchCompanyDialog,
  },
}
</script>

<style lang="less" scoped>
.form {
  margin-top: 15px;
}

.danger {
  color: #ff4949;
}

.btn-group {
  margin-top: 0px;
  .btn {
    width: 100px;
    height: 34px;
    border-radius: 15px;
    background: #cfd5db;
    color: #5e6977;
    &.active {
      background: #20a0ff;
      color: #fff;
    }
  }
}

.card-list,
.card-panel {
  .card {
    margin-top: 10px;
    padding: 12px;
    border: 1px solid #e1e8ee;
    position: relative;
    h4 {
      margin: 0 0 10px 0;
    }
    .form {
      .form-item {
        margin-bottom: 0;
        span {
          margin-right: 10px;
        }
      }
    }
    .btn-area {
      position: absolute;
      right: 0;
      bottom: 0;
      padding-right: 20px;
      .danger {
        color: #ff4949;
      }
    }
  }
}

.card-panel {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .card {
    width: 250px;
    margin-left: 20px;
    padding-bottom: 40px;
    &:nth-child(3n + 1) {
      margin-left: 0;
    }
  }
}

.title {
  font-size: 26px;
  color: #86939e;
  margin: 0;
}
</style>

<style lang="less">
.customer-info .el-tabs .el-tabs__header {
  margin-left: -10px;
  margin-right: -10px;
  .el-tabs__active-bar {
    display: none;
  }
}

.el-form-item.form-item.no-padding .el-form-item__label {
  padding-bottom: 0;
}
.btn-group .btn002{background-color: #c8e7fd !important;border-color: #c8e7fd;}
</style>



// WEBPACK FOOTER //
// CompanyTab.vue?164073be